import type { ReactNode } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ToastProvider } from '@/shared/components/ui/toast';
import { QueryProvider } from './query-provider';

/**
 * Root provider stack. Outer → inner ordering:
 *   1. Router  — every other provider may want to read location/navigate.
 *   2. Query   — most state is server-state, so this is the second-widest.
 *   3. Toast   — UI feedback layer; lives below data so any view can call it.
 *
 * Add new providers (theme, error boundary, etc.) here in the order they
 * need to wrap their children.
 */
export function AppProviders({ children }: { children: ReactNode }) {
    return (
        <BrowserRouter>
            <QueryProvider>
                <ToastProvider>{children}</ToastProvider>
            </QueryProvider>
        </BrowserRouter>
    );
}
